import { render, staticRenderFns } from "./SearchCompanyPaymentTerm.vue?vue&type=template&id=653a52e3&"
import script from "./SearchCompanyPaymentTerm.vue?vue&type=script&lang=js&"
export * from "./SearchCompanyPaymentTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports